/** SRS WhatsApp community / support line (E.164 without +). */
export const SRS_WHATSAPP_E164 = '2348163074798';

export const SRS_WHATSAPP_DISPLAY = '+234 816 307 4798';

const DEFAULT_COMMUNITY_INTRO =
  'Hi SureRightStay, I would like to join the SRS WhatsApp community and get updates on properties and support.';

/** Strip formatting for wa.me / api.whatsapp.com links. */
export function whatsappDigits(phone: string): string {
  return phone.replace(/[^\d]/g, '');
}

export function buildWhatsAppHref(phoneE164: string, message?: string): string {
  const digits = whatsappDigits(phoneE164);
  const base = `https://wa.me/${digits}`;
  if (!message?.trim()) return base;
  return `${base}?text=${encodeURIComponent(message.trim())}`;
}

export function srsWhatsAppCommunityHref(pageLabel?: string): string {
  const page = pageLabel ? ` (from ${pageLabel})` : '';
  return buildWhatsAppHref(
    SRS_WHATSAPP_E164,
    `${DEFAULT_COMMUNITY_INTRO}${page}`,
  );
}
